import React from 'react';
import { FreeBetsWrapper } from '@pascal/pascal-core';
import { LiveBets } from '../../components/liveBets';
import { GameSection } from '../gameSection';
import { CombinationsWrapper } from '../combinationsWrapper';
import { WebLogo } from '../../components/webLogo';
import { BetActionWrapper } from '../betActionWrapper';
import { FooterSectionWrapper } from '../footerSectionWrapper';

export function GameContent() {
  return (
    <div className='turbo-poker-web-wrapper'>
      <WebLogo />
      <FreeBetsWrapper />
      <div className='turbo-poker-web-middle-inner'>
        <div className='tp-mid-web-content'>
          <CombinationsWrapper />
          <GameSection />
        </div>
      </div>
      <div className='turbo-poker-web-bottom-inner'>
        <LiveBets />
        <FooterSectionWrapper>
          <BetActionWrapper />
        </FooterSectionWrapper>
      </div>
    </div>
  );
}
